import React, { createContext, useContext, useState } from 'react';

const AppBarContext = createContext();

export const AppBarProvider = ({ children }) => {
  const [thumbUrl, setThumbUrl] = useState("");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [showCloseIcon, setShowCloseIcon] = useState(false);
  const [showFab, setShowFab] = useState(true);
  const [fallbackIcon, setFallbackIcon] = useState(null);
  const [onThumbnailClick, setOnThumbnailClick] = useState(null);

  const updateTitle = (newThumbUrl, newTitle, newSubtitle, showCloseIcon = false, fallbackIcon = null, thumbnailClickHandler = null) => {
    setThumbUrl(newThumbUrl);
    setTitle(newTitle);
    setSubtitle(newSubtitle);
    setShowCloseIcon(showCloseIcon);
    setFallbackIcon(fallbackIcon);
    setOnThumbnailClick(() => thumbnailClickHandler);
  };

  const toggleFab = (show) => {
    setShowFab(show);
  };

  const toggleCloseIcon = (show) => {
    setShowCloseIcon(show);
  };
  
  return (
    <AppBarContext.Provider value={{ thumbUrl, title, subtitle, updateTitle, showFab, toggleFab, fallbackIcon, toggleCloseIcon, showCloseIcon, onThumbnailClick }}>
      {children}
    </AppBarContext.Provider>
  );
};

export const useAppBar = () => useContext(AppBarContext);
